import { render, staticRenderFns } from "./AdminDash.vue?vue&type=template&id=4286d2b9&scoped=true&"
import script from "./AdminDash.vue?vue&type=script&lang=js&"
export * from "./AdminDash.vue?vue&type=script&lang=js&"
import style0 from "./AdminDash.vue?vue&type=style&index=0&id=4286d2b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286d2b9",
  null
  
)

export default component.exports